<lb-two-column-page-layout>
	<ng-container two-column-page-layout-left-content>
		<div>
			<div class="content-header">
				<md-header size="sm" variant="semibold">Enrollments</md-header>

				<div class="active-inactive">
					<md-button-group>
						<md-button-toggle #activeToggle [disabled]="activeEnrollmentsDisabled()" (click)="displayActiveEnrollments()" value="bold">
							Active
							<md-tag [type]="activeEnrollmentsDisabled() ? 'disabled' : 'default'">{{ activeEnrollments().length }}</md-tag>
						</md-button-toggle>
						<md-button-toggle [disabled]="inactiveEnrollmentsDisabled()" (click)="displayInactiveEnrollments()" value="italic">
							Inactive
							<md-tag [type]="inactiveEnrollmentsDisabled() ? 'disabled' : 'default'">{{ inactiveEnrollments().length }}</md-tag>
						</md-button-toggle>
					</md-button-group>
				</div>
			</div>

			<div class="main-content">
				@for (enrollment of viewableEnrollmentData(); track $index) {
					@if (!usesV2(enrollment)) {
						<lb-enrollment-card
							[enrollment]="enrollment"
							userView="instructor"
							(enrollmentAction)="handleEnrollmentChange($event)"
						></lb-enrollment-card>
					} @else {
						<lrnr-enrollment-card [enrollment]="enrollment" (enrollmentAction)="handleEnrollmentChange($event)"></lrnr-enrollment-card>
					}
				}

				@if (lengthOfEnrollmentData() >= itemsPerPageOptions[0]) {
					<div class="pagination">
						<lb-paginator
							[itemsPerPage]="itemsPerPage()"
							[totalItems]="lengthOfEnrollmentData()"
							[itemsPerPageOptions]="itemsPerPageOptions"
							(pageChange)="onPageChange($event)"
							(pageLengthChange)="onPageLengthChange($event)"
						>
						</lb-paginator>
					</div>
				}
			</div>

			<!-- Comment out for now -->
			<!-- <div class="additional-links">
			<div>
				<a href="#">Ready for another course? <md-icon icon="untitled-ui/arrows/arrow-right"></md-icon></a>
				<span>Learn more about our programs.</span>
			</div>
			<div>
				<a href="#">Questions? <md-icon icon="untitled-ui/arrows/arrow-right"></md-icon></a>
				<span>Our friendly team is here to help.</span>
			</div>
		</div> -->
		</div>
	</ng-container>
	<ng-container two-column-page-layout-right-content>
		<lb-notifications></lb-notifications>
	</ng-container>
</lb-two-column-page-layout>
